<template>
  <AdjustmentTypeCapitalizeBadge :capitalizeIntoCost="params.data?.capitalize_into_cost" />
</template>

<script>
import AdjustmentTypeCapitalizeBadge from './AdjustmentTypeCapitalizeBadge'

export default {
  name: 'AdjustmentTypeCapitalizeBadgeCellRenderer',
  components: { AdjustmentTypeCapitalizeBadge },
  props: {
    params: { type: Object, default: null }
  }
}
</script>
